import React, { useState, useEffect, memo } from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import Modal from '../../common/components/Modal/modal';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { navigate } from 'gatsby';
import styles from './EditLead.module.css';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../components/Dashboard-res/CommonComponent/CommonSelect';
import InputTypeNumber from '../../common/components/InputTypeNumber/InputTypeNumber';
import * as moment from 'moment';
import get from 'lodash/get';
import CommonBtn from '../LeadProfile/CommonBtn/CommonBtn';
import Audit from '../../containers/Audit/Audit';
import {
  cityOptions,
  updateStatusOptions,
  updateSubStatusForOpen,
  updateSubStatusForFollowUp,
  updateSubStatusForRejected,
  timeIntalval
} from './EditLeadOptions';
import { addOrEditLead, getLoanProduct } from '../../common/constants/api';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../common/utils/applicantionInfo';
import _, { min, stubFalse } from 'lodash';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import PopUp from '../../common/components/PopUp/PopUp';
import CommonDatePicker from '../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import Toast from '../../common/components/Toast/Toast';

const validationSchema = Yup.object().shape({
  emailId: Yup.string()
    .notRequired()
    .email('Please enter email address')
    .max(50, 'Email adress is Too Long!')
    .nullable(),

  loanType: Yup.object().shape({
    value: Yup.string().required('Required.')
  }),

  loanAmount: Yup.string().when('updateStatus', {
    is: updateStatus => updateStatus.value === 'INTERESTED',
    then: Yup.string().required('Required')
  })
});

function subStatus(status) {
  if (status === 'OPEN') {
    return updateSubStatusForOpen;
  } else if (status === 'FOLLOW_UP' || status == 'FOLLOW UP') {
    return updateSubStatusForFollowUp;
  } else if (status === 'LEAD_REJECTED' || status == 'LEAD REJECTED') {
    return updateSubStatusForRejected;
  } else {
    return [];
  }
}
const EditLead = ({ showModal, setShowModal, rowData, onUpdation }) => {
  const {
    editContainer,
    modalWidth,
    edit_details_container,
    formHeight
  } = styles;

  const [date, setDate] = useState(null);
  const [showAuditTrail, setShowAuditTrail] = useState(false);
  const [focussed, setFocussed] = useState(false);
  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  return (
    <Formik
      initialValues={{
        firstName: '',
        lastName: '',
        emailId: '',
        city: { value: '', label: 'Select City' },
        loanType: { value: '', label: 'Select Loan Type' },
        loanAmount: '',
        otherCityName: '',
        updateStatus: { value: '', label: 'Update  Status' },
        updateSubStatus: { value: '', label: 'Update Sub Status' },
        followTime: { value: '', label: 'Follow-up Time' },
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: moment().format('MM'),
          label: moment().format('MMMM')
        },
        year: {
          value: moment().format('YYYY'),
          label: moment().format('YYYY')
        },
        initialLoading: true
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting
      }) => {
        const [showCity, setShowCity] = useState(false);

        useEffect(() => {
          if (!values.initialLoading)
            setFieldValue('updateSubStatus', {
              value: '',
              label: 'Update Sub Status'
            });
        }, [values.updateStatus.value]);

        useEffect(() => {
          getLoanProduct()
            .then(res => {
              setProductTypeOptions(res);
            })
            .catch(err => {
              setShow(false);
              setShowModal(false);
            });
        }, []);
        function productTypeOptionsFun() {
          return productTypeOptions.map(each => {
            return {
              label: each?.displayName,
              value: each?.id
            };
          });
        }

        function updateLead() {
          let body = {
            name: {
              firstName: values?.firstName || '',
              middleName: '',
              lastName: values?.lastName || ''
            },
            productId: values?.loanType?.value || '',
            leadStatus: values?.updateStatus?.value,
            subStatus: values?.updateSubStatus?.value,
            loanAmount: values?.loanAmount,
            city:
              values?.city?.value != 'Others'
                ? values?.city.value
                : values?.otherCityName,

            followDateTime: (() => {
              if (values.date?.value) {
                let splitValue = values?.followTime?.value.split(':');

                const hour = parseInt(splitValue[0], 10);
                const minute = parseInt(splitValue[1], 10);
                let date = new Date(
                  values.year.value,
                  parseInt(values.month.value) - 1,
                  values.date.value,
                  hour || 0,
                  minute || 0
                );
                return date;
              }
            })()
          };

          if (values?.emailId) {
            body.email = values?.emailId;
          }

          setType('loading');
          setText('Upadating The Lead Please Wait...');
          setShow(true);
          let applicationDetails = {
            leadId: rowData.leadId,
            leadApplicantId: rowData.leadMainApplicantId,
            applicationStatus: rowData.status,
            leadData: rowData
          };
          setApplicantionInfo(applicationDetails);
          addOrEditLead(body, getApplicantionInfo().leadId)
            .then(res => {
              setShowModal(false);

              if (values.updateStatus.value == 'INTERESTED') {
                return navigate(
                  `/app/dashboard/lead/pd?loanType=${values?.loanType?.value ||
                    '1'}`
                );
              } else {
                Toast(
                  'success',
                  'Lead has been edited successfully',
                  '3000',
                  'top-center'
                );
              }
              if (typeof onUpdation == 'function') onUpdation();
            })
            .catch(error => {
              setShow(false);
              setShowModal(false);
            });
        }
        useEffect(() => {
          setFieldValue('firstName', rowData?.leadName?.firstName);
          setFieldValue('lastName', rowData?.leadName?.lastName);
          setFieldValue('emailId', rowData?.emailId);
          setFieldValue('loanAmount', rowData?.loanAmount);

          for (let i = 0; i <= cityOptions?.length; i++) {
            if (
              cityOptions[i]?.value?.toLowerCase() ==
              rowData?.propertyCity?.toString().toLowerCase()
            ) {
              setFieldValue('city', {
                value: rowData?.propertyCity || '',
                label: rowData?.propertyCity || 'Select City'
              });
              break;
            } else if (rowData?.propertyCity && i == cityOptions?.length - 1) {
              setFieldValue('city', {
                value: 'Others',
                label: 'Others'
              });
              setFieldValue('otherCityName', rowData?.propertyCity);
              setShowCity(true);
            }
          }

          updateStatusOptions.map((each, index) => {
            let value = each?.value?.replace(/_/g, ' ')?.toLowerCase();
            let lead_status = rowData?.status?.toString()?.toLowerCase();
            if (value == lead_status) {
              return setFieldValue('updateStatus', {
                label: each.label,
                value: each.value
              });
            } else if (index == updateStatusOptions?.length - 1) {
              return setFieldValue('updateStatus', {
                label: 'Open',
                value: 'OPEN'
              });
            }
          });

          updateSubStatus(rowData);
        }, []);

        const updateSubStatus = rowData => {
          if (
            typeof subStatus(rowData.status?.toString().toUpperCase()) ==
            'object'
          ) {
            subStatus(rowData.status?.toString().toUpperCase()).map(each => {
              let label = each.label.toLowerCase();
              let lead_sub_status = rowData.subStatus?.toString().toLowerCase();
              if (label == lead_sub_status) {
                return setFieldValue('updateSubStatus', {
                  label: each.label,
                  value: each.value
                }).then(res => setFieldValue('initialLoading', false));
              }
            });
          }
        };

        useEffect(() => {
          if (productTypeOptions && productTypeOptions.length != 0)
            productTypeOptions.map(each => {
              if (
                each.displayName?.toLowerCase() ==
                rowData?.loanProduct?.toLowerCase()
              ) {
                setFieldValue('loanType', {
                  value: each.id,
                  label: rowData?.loanProduct
                });
              }
            });
        }, [productTypeOptions]);

        return (
          <React.Fragment>
            <PopUp type={type} text={text} setShow={setShow} show={show} />

            <Modal
              show={showModal}
              setShow={setShowModal}
              classStyle={modalWidth}
              styleContainer={{
                marginTop: '65px',
                maxHeight: '90%',
                maxWidth: '650px'
              }}
              title={
                <span className="font-bold font-roboto text-xl text-black-0">
                  Edit Lead
                </span>
              }
            >
              <Form
                autoComplete="off"
                onSubmit={handleSubmit}
                className={`pt-2 pb-6 overflow-auto mb-4 ${formHeight}`}
              >
                <Audit
                  setShowAuditTrail={setShowAuditTrail}
                  showAuditTrail={showAuditTrail}
                />
                <div className="w-full">
                  <header
                    style={{
                      borderBottom: '1px solid #DEDEDE',
                      bottom: '13px'
                    }}
                    className="flex ml-auto relative pb-3 my-5"
                  >
                    <div className="relative ml-auto">
                      <CommonBtn
                        value="Audit Trail"
                        onClick={() => setShowAuditTrail(true)}
                      />
                    </div>
                  </header>
                  <div
                    className={`${editContainer} bg-blue-800 flex flex-wrap p-3 rounded`}
                  >
                    <div className="pb-1">
                      <span className="text-black-1020">Lead ID :</span>
                      <span className="text-black-600 pl-2 pr-4">
                        {rowData?.leadId || ''}
                      </span>
                    </div>
                    <div className="pb-1">
                      <span className="text-black-1020">Mobile Number :</span>
                      <span
                        className="text-black-600 pl-2 pr-4"
                        style={{
                          letterSpacing: '1px'
                        }}
                      >
                        {rowData?.leadApplicantPhone
                          ? '+91 ' + rowData?.leadApplicantPhone
                          : 'NA'}
                      </span>
                    </div>
                    <div className="pb-1">
                      <span className="text-black-1020">Assigned RM :</span>
                      <span className="text-black-600 pl-2 pr-4">
                        {`${rowData?.rmName?.firstName || ''} 
                        ${rowData?.rmName?.middleName || ''} 
                        ${rowData?.rmName?.lastName || ''}`}
                      </span>
                    </div>
                    <div className="pb-1">
                      <span className="text-black-1020">Source :</span>
                      <span className="text-black-600 pl-2 pr-4">
                        {rowData?.leadSource != 'BP' &&
                        rowData?.leadSource != 'Direct'
                          ? 'B2C'
                          : rowData?.leadSource}
                      </span>
                    </div>
                    <div className="pb-1">
                      <span className="text-black-1020">Sub Source :</span>
                      <span className="text-black-600 pl-2 pr-4">
                        {rowData?.leadSource != 'BP' &&
                        rowData?.leadSource != 'Direct'
                          ? rowData?.leadSource
                          : '---'}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`${edit_details_container} px-5 md:px-0 mb-10 font-normal font-roboto text-sm text-black-500`}
                  >
                    <CommonInput
                      name="firstName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.firstName}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                      legendName="First Name"
                      error={touched.firstName && errors.firstName}
                      errorMsg={errors.firstName}
                      touched={touched.firstName}
                    />
                    <CommonInput
                      name="lastName"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.lastName}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                      legendName="Last Name"
                      error={touched.lastName && errors.lastName}
                      errorMsg={errors.lastName}
                      touched={touched.lastName}
                    />
                    <CommonInput
                      name="emailId"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.emailId}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                      legendName="Email ID"
                      error={touched.emailId && errors.emailId}
                      errorMsg={errors.emailId}
                      touched={touched.emailId}
                    />
                    <CommonSelect 
                      name="city"
                      value={values.city}
                      onChange={e => {
                        setFieldValue('city', e);
                        if (e.value === 'Others') {
                          setShowCity(true);
                        } else {
                          setShowCity(false);
                        }
                      }}
                      onBlur={() => {
                        setFieldTouched('city', true, true);
                      }}
                      options={cityOptions}
                      dropdownStyle={{
                        top: '52px',
                        fontSize: '16px'
                      }}
                      stylesContainer={{
                        height: '52px'
                      }}
                      styleText={{
                        fontSize: '14px',
                        padding: '0 20px'
                      }}
                      error={touched.city && get(errors, 'city.value', false)}
                      touched={touched.city}
                    />
                    {showCity && (
                      <CommonInput
                        name="otherCityName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.otherCityName}
                        stylesContainer={{
                          maxWidth: '100%'
                        }}
                        legendName="Other City Name"
                        error={touched.otherCityName && errors.otherCityName}
                        errorMsg={errors.otherCityName}
                        touched={touched.otherCityName}
                      />
                    )}

                    <CommonSelect sort={true}
                      name="loanType"
                      value={values.loanType}
                      onChange={e => {
                        setFieldValue('loanType', e);
                      }}
                      onBlur={() => {
                        setFieldTouched('loanType', true, true);
                      }}
                      options={productTypeOptionsFun()}
                      dropdownStyle={{
                        top: '52px',
                        fontSize: '16px'
                      }}
                      stylesContainer={{
                        height: '52px'
                      }}
                      styleText={{
                        fontSize: '14px',
                        padding: '0 20px'
                      }}
                      error={
                        touched.loanType && get(errors, 'loanType.value', false)
                      }
                      touched={touched.loanType}
                    />

                    <InputTypeNumber
                      name="loanAmount"
                      value={values.loanAmount}
                      maxLength={15}
                      minLength={0}
                      legendName="Loan Amount"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      stylesContainer={{
                        maxWidth: '100%'
                      }}
                      inputStyle={{
                        height: '30px',
                        paddingLeft: '40px',
                        paddingTop: '10px',
                        letterSpacing: '1px'
                      }}
                      iconStyle={{ marginTop: '12px' }}
                      error={touched.loanAmount && errors.loanAmount}
                      errorMsg={errors.loanAmount}
                      touched={touched.loanAmount}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      showInText={false}
                    />
                  </div>
                </div>

                <div>
                  <button
                    disabled={!_.isEmpty(errors)}
                    onClick={() => {
                      updateLead();
                    }}
                    type="submit"
                    className={
                      'submitButton text-16 w-56 h-12 font-medium  font-roboto'
                    }
                  >
                    Update
                  </button>
                </div>
              </Form>
            </Modal>
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default memo(withErrorHandler(EditLead));
